import "../../templates/_partials/main-navigation/main-navigation-desktop.js";
import "../../templates/_partials/main-navigation/main-navigation-mobile.js";
import "../../templates/_partials/top-navigation/top-navigation.js";
import "../../templates/_partials/cards/cards-study-area.js";
import "../../templates/_partials/cards/cards.js";
import "../../templates/_partials/search-field/search-field.js";
import "../../templates/_partials/cookie-notification/cookie-notification.js";
import "../../templates/_partials/map/map.js";
import "../../templates/_partials/modal/modal-print.js";
import '../../templates/_partials/header/header-course-sticky.js'
import '../../templates/_partials/header/header-course-v2-sticky.js'
import "../../templates/_partials/course-content/course-content-actions.js";
import "../../templates/_partials/header/header.js";
import "../../templates/_partials/unsupported-message/unsupported-message.js";
import "../../templates/_partials/jump-to-top/jump-to-top.js";
import "../../templates/_partials/basic-tooltip/basic-tooltip.js";
import "../../templates/_partials/course-list-cta/course-list-cta.js";
import "../../templates/_partials/floating-widget/floating-widget.js";
